import api from '../../../services/api';
import { getUserFactoryId } from '../../../../index';
import buildQuery from 'odata-query'

export const STRUCTURE_URL = '/structure'

export const getAll = () => {
    return api.get(`${STRUCTURE_URL}/odata?$select=id,name,code,typeId&$filter=factoryId+eq+${getUserFactoryId()} and status+eq+true&$expand=father($select=name)`);
}

export const apiGETstructure = ( factoryId ) => {
    return api.get('structure/odata/' + buildQuery({
        filter: {
            not:
            {
                type: {
                    name: 'Ativo'
                }
            },
            factoryId: factoryId,
            status: true
        },
        select: ['id', 'name'],
        expand:{
            father:
            {
                select: ['name']
            }
        }
    }));
}